import React from "react"
import PropTypes from "prop-types"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"
import { centsToCurrencyStr } from "shared/pac/helperFunctions"

/**
 * Cell component to render amounts as a currency string
 *
 * TODO support other currencies
 */
export const CurrencyCell = (props) => {
    const formattingFn = (value) => (value || value === 0 ? centsToCurrencyStr(parseInt(value)) : "")
    return (
        <CellWrapper {...props} formattingFn={formattingFn} isNumeric>
            {formattingFn(props.children)}
        </CellWrapper>
    )
}

CurrencyCell.propTypes = {
    /** Amount, in cents, to display */
    cellValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // Robust against either a Number or a String.
}

export default CurrencyCell
